import { render, staticRenderFns } from "./ContainerPopup.vue?vue&type=template&id=2b025ada&scoped=true"
import script from "./ContainerPopup.vue?vue&type=script&lang=js"
export * from "./ContainerPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b025ada",
  null
  
)

export default component.exports